import { render, staticRenderFns } from "./TBadge.vue?vue&type=template&id=f2441e90&scoped=true&"
import script from "./TBadge.vue?vue&type=script&lang=js&"
export * from "./TBadge.vue?vue&type=script&lang=js&"
import style0 from "./TBadge.vue?vue&type=style&index=0&id=f2441e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2441e90",
  null
  
)

/* custom blocks */
import block0 from "./TBadge.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports